<template>
  <DepartmentUserForm :userId="userId" :departmentId="departmentId" />
</template>

<script>
import DepartmentUserForm from "@/components/DepartmentsDetail/DepartmentUserForm.vue";
export default {
  components: {
    DepartmentUserForm,
  },
  data() {
    return {
      userId: this.$route.params.userId,
      departmentId: this.$route.params.departmentId,
    };
  },
};
</script>

<style></style>
